/* eslint-disable max-len */
import React from 'react';

const IndentIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <g fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M4.2 5h10.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm5 4h5.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm-5 4h10.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2z"
      />
      <path d="M4.058 10.662L5.214 9.5 4.059 8.339a.2.2 0 0 1 0-.283l.414-.414a.2.2 0 0 1 .283 0L6.472 9.36a.2.2 0 0 1 0 .282l-1.717 1.717a.2.2 0 0 1-.282 0l-.414-.414a.2.2 0 0 1 0-.282z" />
    </g>
  </svg>
);

export default IndentIcon;
